// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__Gze82","headerContent":"Header_headerContent__prDjQ","title":"Header_title__l+wMf","languageSelect":"Header_languageSelect__JDACE"};